// extracted by mini-css-extract-plugin
export default {"modeColor":"Icons_modeColor__nStf+","modeColorWhite":"Icons_modeColorWhite__1pY2N"};